import React from 'react'
import { TableProps } from 'antd/lib/table'

import { ColumnProps } from 'src/components/Ant/Table'
import { currencyMask } from 'src/components/Formik'
import { Text } from 'src/components/Ant'

import R6HeaderTable, { R6HeaderTableGeneric } from './r6-header-table-generic'

const columns: ColumnProps<R6HeaderTableGeneric>[] = [
  {
    align: 'center',
    dataIndex: 'name',
    key: 'name',
    render: (value: string) => {
      switch (value) {
        case 'AD':
          return <Text>AZUL</Text>
        case 'G3':
          return <Text>GOL</Text>
        case 'LA':
        case 'JJ':
          return <Text>LATAM</Text>
        default:
          return <Text>{value}</Text>
      }
    },
    title: 'web.report.6.header.companies.company'
  },
  {
    align: 'center',
    dataIndex: 'total',
    key: 'total',
    render: (value: number) => (
      <Text>
        {
          currencyMask({
            formatStr: true,
            precision: 2,
            value
          }).maskedValue
        }
      </Text>
    ),
    title: 'web.report.6.header.companies.total'
  },
  {
    align: 'center',
    dataIndex: 'percent',
    key: 'percent',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.6.header.companies.percent'
  }
]
function R6HeaderTableCompanies({
  dataSource
}: TableProps<R6HeaderTableGeneric>) {
  return <R6HeaderTable columns={columns} dataSource={dataSource} />
}

export default R6HeaderTableCompanies
